export const WEBSITE_RESET_STATE = 'WEBSITE_RESET_STATE';
export const WEBSITE_CURRENT_ITEM = 'WEBSITE_CURRENT_ITEM';

export const WEBSITE_REQUEST_LOADING = 'WEBSITE_REQUEST_LOADING';
export const WEBSITE_REQUEST_SUCCESS = 'WEBSITE_REQUEST_SUCCESS';
export const WEBSITE_REQUEST_FAILED = 'WEBSITE_REQUEST_FAILED';

export const WEBSITE_CURRENT_ACTION = 'WEBSITE_CURRENT_ACTION';
export const WEBSITE_RESET_ACTION = 'WEBSITE_RESET_ACTION';